import { Spinner } from '@vst/beam';

import { CustomDecorativeModal } from '../DecorativeModal';

import styles from './styles.module.scss';

type LoadingModalProps = {
  isOpen: boolean;
  description?: string;
  handleClose?(): void;
};

export const LoadingModal = ({
  isOpen,
  description = '',
  handleClose,
}: LoadingModalProps) => {
  return (
    <CustomDecorativeModal
      header={undefined}
      isOpen={isOpen}
      actions={{ primary: { label: '', style: { display: 'none' } } }}
      surfaceProps={{ className: styles['actionlessModal'] }}
      onClose={handleClose}
    >
      <Spinner
        size="small"
        className={styles['customSpinner']}
        description={description}
      />
    </CustomDecorativeModal>
  );
};
